
export default function Footer() {
  const quickLinks = [
    { name: 'Accueil', href: '/' },
    { name: 'Comment ça marche', href: '/#solution' },
    { name: 'Témoignages', href: '/#testimonials' },
    { name: 'FAQ', href: '/#faq' },
    { name: 'Contact', href: '/#contact-form' }
  ];

  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Logo et description */}
          <div className="lg:col-span-2">
            <div className="mb-6">
              <h3 className="text-2xl font-bold mb-2" style={{ fontFamily: '"Pacifico", serif' }}>
                VirtualEat
              </h3>
              <p className="text-gray-300 leading-relaxed">
                Nous aidons les restaurants à augmenter leurs ventes de +20 à +40% grâce aux marques virtuelles. 
                100% gratuit, aucun risque, résultats garantis.
              </p>
            </div>
            
            <div className="flex space-x-4">
              <img 
                src="https://static.readdy.ai/image/a343775702a04f57d19e2d80438d20f8/5bf130391ed6bd3111354f4f2ad640e2.png"
                alt="Uber Eats"
                className="w-12 h-8 object-contain opacity-70 hover:opacity-100 transition-opacity cursor-pointer"
              />
              <img 
                src="https://static.readdy.ai/image/a343775702a04f57d19e2d80438d20f8/35956f4f4d3d7d170ad0681dfb720bcf.png"
                alt="Deliveroo"
                className="w-12 h-8 object-contain opacity-70 hover:opacity-100 transition-opacity cursor-pointer"
              />
              <div className="h-8 flex items-center">
                <span className="text-lg font-bold text-orange-500 opacity-70 hover:opacity-100 transition-opacity cursor-pointer">Just Eat</span>
              </div>
            </div>
          </div>
          
          {/* Liens rapides */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Liens rapides</h4>
            <ul className="space-y-2">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <a href={link.href} className="text-gray-300 hover:text-[#9EFD38] transition-colors cursor-pointer">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          
          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <div className="space-y-3">
              <div className="flex items-center">
                <i className="ri-mail-line text-[#9EFD38] mr-3"></i>
                <a href="mailto:gabrielmarandyukpro@gmail.com" className="text-gray-300 hover:text-white transition-colors">
                  gabrielmarandyukpro@gmail.com
                </a>
              </div>
              <div className="flex items-center">
                <i className="ri-whatsapp-line text-[#9EFD38] mr-3"></i>
                <a href="https://wa.me/32493813552" className="text-gray-300 hover:text-white transition-colors">
                  WhatsApp uniquement : +32 493 81 35 52
                </a>
              </div>
              <div className="flex items-start">
                <i className="ri-time-line text-[#9EFD38] mr-3 mt-1"></i>
                <span className="text-gray-300">
                  Lun-Ven: 9h-18h<br />
                  Réponse sous 24h
                </span>
              </div>
            </div>
          </div>
        </div>
        
        {/* Séparateur */}
        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm mb-4 md:mb-0">
              © 2024 VirtualEat. Tous droits réservés.
            </p>
            
            <div className="flex items-center space-x-6">
              <a href="/mentions-legales" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">
                Mentions légales
              </a>
              <a href="/confidentialite" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">
                Confidentialité
              </a>
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-[#9EFD38] text-sm transition-colors cursor-pointer"
              >
                Made with Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
